export default __webpack_public_path__ + "2cd770e0d94affb20b20bae824ff7cd6.svg";